import { AddressValue } from "./address.utils";

export const formatPocName = (addressValue: AddressValue): string | null => {
  const first = addressValue.poc_first_name;
  const last = addressValue.poc_last_name;
  if (first || last) {
    return [first, last].filter(Boolean).join(" ");
  }
  return addressValue.poc_email ?? null;
};

export interface AddressLines {
  postalLines: string[];
  /** metadata fields (Tax ID, CRM ID, etc.) */
  metaFields: { label: string; value: string }[];
}

export const getAddressDisplayLines = (
  addressValue: AddressValue,
  t: (key: string) => string
): AddressLines => {
  const streetParts = [
    addressValue.address1,
    addressValue.address2,
    addressValue.address3,
  ]
    .filter(Boolean)
    .join(", ");

  const line2 = [
    addressValue.city,
    addressValue.state_display_name ?? addressValue.state,
  ]
    .filter(Boolean)
    .join(", ");

  const cityLineParts = [line2, addressValue.postal_code].filter(Boolean);

  const postalLines = [
    addressValue.company_name,
    streetParts || null,
    cityLineParts.length ? cityLineParts.join(" ") : null,
    addressValue.country_code ?? addressValue.country_name ?? null,
  ].filter((line): line is string => Boolean(line));

  const pocName = formatPocName(addressValue);

  const metaFields: { label: string; value: string }[] = [
    addressValue.tax_id
      ? { label: t("Tax ID"), value: addressValue.tax_id }
      : null,
    addressValue.crm_id
      ? { label: t("CRM ID"), value: addressValue.crm_id }
      : null,
    addressValue.location_id
      ? { label: t("Location ID"), value: addressValue.location_id }
      : null,
    pocName ? { label: t("Point of Contact"), value: pocName } : null,
  ].filter((f): f is { label: string; value: string } => f !== null);

  return { postalLines, metaFields };
};
